import { render, staticRenderFns } from "./VPSResetPassword.vue?vue&type=template&id=c9d3c374&scoped=true"
import script from "./VPSResetPassword.vue?vue&type=script&lang=js"
export * from "./VPSResetPassword.vue?vue&type=script&lang=js"
import style0 from "./VPSResetPassword.vue?vue&type=style&index=0&id=c9d3c374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d3c374",
  null
  
)

export default component.exports